import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RWDService {
  private initialised = false;

  constructor(private responsive: BreakpointObserver) {
    const landscapeSmall = '(max-width: 800px) and (orientation: landscape)';
    this.responsive
      .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape, Breakpoints.Tablet, landscapeSmall])
      .subscribe((result) => {
        this.isPhonePortrait = false;
        this.isPhoneLandscape = false;
        this.dashboardResolutionSmall = false;
        this.isTablet = false;

        const breakpoints = result.breakpoints;
        if (breakpoints[landscapeSmall]) {
          this.dashboardResolutionSmall = true;
        }

        if (breakpoints[Breakpoints.HandsetPortrait]) {
          this.isPhonePortrait = true;
        } else if (
          breakpoints[Breakpoints.HandsetLandscape] ||
          breakpoints[Breakpoints.TabletPortrait] ||
          breakpoints[Breakpoints.TabletLandscape]
        ) {
          this.isPhoneLandscape = true;
          if (breakpoints[Breakpoints.TabletPortrait] || breakpoints[Breakpoints.TabletLandscape]) {
            this.isTablet = true;
          }
        }

        if (!this.initialised) {
          this.initialised = true;
          this.onInit();
        }
      });
  }

  private onInit() {
    if (!this.isSmallDevice) this.openNavPanel();
  }

  public isPhonePortrait: boolean = false;
  public isPhoneLandscape: boolean = false;
  public isTablet: boolean = false;
  public dashboardResolutionSmall: boolean = false;

  public navPanelOpened: boolean = false;

  public get isSmallDevice() {
    return this.isPhonePortrait || this.isPhoneLandscape;
  }

  public openNavPanel() {
    this.navPanelOpened = true;
  }

  public closeNavPanel() {
    this.navPanelOpened = false;
  }

  public toggleNavPanel() {
    this.navPanelOpened = !this.navPanelOpened;
  }
}
